import React, { useState, useCallback } from "react";

// libs
import { Row, Spin, Tooltip, Icon } from "antd";
import moment from "moment";

// Styles
import { Card } from "../../styles";

// Components
import useKpiContext from "../../../../hooks/useKpiContext";

//Services
import { numberMask } from "../../../../services/helpersMethodsService";

//Icons
import InfoIcon from "../../../../components/utils/icons/info";

const KpiIncrementalMargin = () => {
  const { kpiIncrementalMargin: kpiData, updateKpiSelected } = useKpiContext();
  // const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isTooltipErrorVisible, setIsTooltipErrorVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    // setIsTooltipVisible(true);
    // setTimeout(() => {
    //   setIsTooltipVisible(false);
    // }, 2000);
  }, []);

  const handleShowTooltipError = useCallback(() => {
    setIsTooltipErrorVisible(true);
    setTimeout(() => {
      setIsTooltipErrorVisible(false);
    }, 2000);
  }, []);

  return (
    <Card
      xs={23}
      sm={23}
      md={10}
      lg={7}
      xl={7}
      className={
        kpiData.isSelected
          ? kpiData?.data.isComplete
            ? " border-green"
            : " border-yellow"
          : ""
      }
      onClick={() =>
        !kpiData.isLoading ? updateKpiSelected("MARGEM_INCREMENTAL") : null
      }
    >
      <Spin spinning={kpiData.isLoading} size="small">
        <div className="header">
          <span>
            <Tooltip
              visible={isTooltipErrorVisible}
              title={`Último processamento: ${
                kpiData.data?.kpiDate != null
                  ? moment(kpiData.data.kpiDate).format("DD/MM/YYYY")
                  : "Sem data"
              }`}
            >
              {kpiData.data.error ? (
                <Icon
                  type="exclamation-circle"
                  className="iconError"
                  theme="filled"
                  onClick={() => handleShowTooltipError()}
                />
              ) : null}
            </Tooltip>
            Margem Incremental
          </span>
          <span></span>
        </div>
        <div className="content">
          <Row type="flex">
            <span className="span-font">
              <b>
                {kpiData?.data?.kpiValue == null
                  ? "-"
                  : numberMask(
                      kpiData?.data?.kpiValue || 0,
                      kpiData?.data?.isMonetary
                    )}{" "}
              </b>
              {kpiData?.data?.valueType}
            </span>
          </Row>
          <Row type="flex">
            <InfoIcon onClick={() => handleShowTooltip()} />
          </Row>
        </div>
      </Spin>
    </Card>
  );
};

export default KpiIncrementalMargin;
